import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconHorizontalAlignRightComponent } from "./med-icon-horizontal-align-right.component";

@NgModule({
  declarations: [
    MedIconHorizontalAlignRightComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconHorizontalAlignRightComponent,
  ],
})
export class MedIconHorizontalAlignRightModule { }
